export const getStringBetween = (text: string, start: string, end: string) => {
  const result = text.match(new RegExp(start + '(.*)' + end))
  return result?.[1]
}
